import { gql } from 'graphql-request'

const LIVE_CHECKIN_MONTH_FIELDS = `
  id
  userId
  liveCheckinLevelId
  countryCodeId
  utc
  country
  yearCheckin
  monthCheckin
  dateInitial
  dateFinal
  pointsAccumulated
  levelCurrent
  active
  createdAt
  updatedAt
`

export const GET_OR_CREATE_LIVE_CHECKIN_MONTH_CURRENT = gql`
  mutation GET_OR_CREATE_LIVE_CHECKIN_MONTH_CURRENT($userId: Int!) {
    getOrCreateLiveCheckinMonthCurrent(userId: $userId) {
      status
      error
      data { ${LIVE_CHECKIN_MONTH_FIELDS} }
    }
  }
`

export const GET_LIVE_CHECKIN_MONTH_FIRST = gql`
  query GET_LIVE_CHECKIN_MONTH_FIRST(
    $userId: Int
    $yearCheckin: Int
    $monthCheckin: Int
  ) {
    getLiveCheckinMonthFirst(
      userId: $userId
      yearCheckin: $yearCheckin
      monthCheckin: $monthCheckin
    ) {
      status
      error
      data { ${LIVE_CHECKIN_MONTH_FIELDS} }
    }
  }
`
